import { Col, Row } from 'antd';
import React from 'react';
import { useParams } from 'react-router';

import { useGetVariantDetailQuery } from '../../api/variantApi';
import DetailCard from '../components/DetailCard';
import VariantUpdatePrimaryTranscript from '../components/VariantUpdatePrimaryTranscript';
import { VARIANT_STAGE_TYPES } from '../constants';
import { useVariantStep } from '../hooks/use_variant_step';
import Interpretation from '../interpretation/Interpretation';
import GeneProteinFactsSection from './GeneProteinFactsSection';
import MolecularImpactHeader from './MolecularImpactHeader';
import ReferencesSection from './ReferencesSection';
import SilicoPredictionSection from './SilicoPredictionSection';

const MolecularImpact = () => {
  const params = useParams();

  // Read the selected variant straight from the RTK Query cache (populated
  // by the workflow loader) rather than a Redux selector.
  const { data: variant } = useGetVariantDetailQuery(
    { variant_id: params.vid },
    { skip: !params.vid },
  );

  const stageInfo = useVariantStep(VARIANT_STAGE_TYPES.MOLECULAR_IMPACT);

  return (
    <div className="molecular-impact">
      <VariantUpdatePrimaryTranscript />
      <Row gutter={[8, 8]} className="workflow-stage-content-container">
        <Col flex={'auto'} className="workflow-stage-left-col">
          <DetailCard>
            <MolecularImpactHeader />
          </DetailCard>
          <SilicoPredictionSection />
          <GeneProteinFactsSection />
          <ReferencesSection />
        </Col>

        {stageInfo && variant && (
          <Interpretation
            variant={variant}
            stepLabel="Molecular Impact"
            stepStatus={stageInfo.status}
            stepId={stageInfo.id}
            stepType={stageInfo.stage_type}
          />
        )}
      </Row>
    </div>
  );
};

export default MolecularImpact;
